import React, { useState } from "react";
import { motion } from "framer-motion";
import { certifications } from "./constants";
import "../styles/certifications.css";

function Certifications() {
  const [selectedPdf, setSelectedPdf] = useState(null);

  return (
    <motion.div
      className="certifications__main page"
      variants={{
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      <h1 className="page-heading">Certifications & Credentials</h1>
      <p className="page-subtitle">
        Professional certifications and training credentials
      </p>

      <div className="certifications__grid">
        {certifications.map((cert) => (
          <div className="cert__card" key={cert.title}>
            {cert.type === "image" && cert.file && (
              <div className="cert__image">
                <img
                  src={require(`../images/${cert.file}`)}
                  alt={cert.title}
                />
              </div>
            )}
            {cert.type === "pdf" && cert.file && (
              <div className="cert__preview">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 5a.5.5 0 0 1 .5.5v3.362l.854-1.431a.5.5 0 0 1 .854.354v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 1 1 1 0v2.508L7.5 8.71V5.5A.5.5 0 0 1 8 5z" />
                  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                </svg>
                <p>PDF Certificate</p>
              </div>
            )}
            {cert.type === "credential" && (
              <div className="cert__badge">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="40"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z" />
                </svg>
              </div>
            )}

            <div className="cert__content">
              <h3>{cert.title}</h3>
              {cert.description && (
                <p className="cert__description">{cert.description}</p>
              )}
              <p className="cert__issuer">{cert.issuer}</p>
              <p className="cert__date">{cert.date}</p>

              {cert.type === "pdf" && cert.file && (
                <div className="cert__actions">
                  <button
                    className="cert__btn cert__btn--preview"
                    onClick={() => setSelectedPdf(cert)}
                  >
                    Preview
                  </button>
                  <a
                    href={require(`../images/${cert.file}`)}
                    download={cert.file}
                    className="cert__btn cert__btn--download"
                  >
                    Download
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {selectedPdf && (
        <div className="cert__modal" onClick={() => setSelectedPdf(null)}>
          <div className="cert__modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="cert__modal-close"
              onClick={() => setSelectedPdf(null)}
            >
              ✕
            </button>
            <h2>{selectedPdf.title}</h2>
            <object
              data={require(`../images/${selectedPdf.file}`)}
              type="application/pdf"
              width="100%"
              height="600px"
            >
              <p>
                Unable to display PDF.
                <a
                  href={require(`../images/${selectedPdf.file}`)}
                  download={selectedPdf.file}
                >
                  Download instead
                </a>
              </p>
            </object>
          </div>
        </div>
      )}
    </motion.div>
  );
}

export default Certifications;
